import styled from '@emotion/styled';
import { BsList, BsX } from 'react-icons/bs';

interface MobileTogglerProps {
	toggled: boolean;
	toggleFunc: () => void;
}

const MobileToggler = ({ toggled, toggleFunc }: MobileTogglerProps) => {
	const StyledDiv = styled.div`
		display: none;
		text-align: center;
		align-items: center;
		justify-self: center;
		color: var(--bs-700);
		display: none;
		z-index: 112;

		@media only screen and (max-width: 991px) {
			display: block;
		}
	`;
	return (
		<StyledDiv className="mobile-toggler" onClick={toggleFunc}>
			{toggled ? <BsX size={24} /> : <BsList size={24} />}
		</StyledDiv>
	);
};

export default MobileToggler;
